/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { PlusExtraLargeIcon } from 'shared/components/Icons';
import categoryImage from 'assets/images/shoes.png';

const Categories = ({ data, title }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);

  const goToProducts = item => {
    history.push(`/likiees/category/${item.tag}/${item.name}`);
  };

  if (!data || !data.length) return null;

  const result = !showMore ? [...data].splice(0, 5) : [...data];

  return (
    <div className='mb-20 mb-md-0'>
      <h1 className='mb-md-12 mb-8'>{title}</h1>
      <div className='d-flex row flex-wrap px-4 px-md-0 onboarding-sel-category'>
        {result.map(item => {
          return (
            <div key={item.tag} className='category-block cursor-pointer' onClick={goToProducts.bind(null, item)}>
              <img src={item.icon} alt={item.name} />
              <div className='ctg-info'>
                <p className='mb-4 text-lg fw-500'>{t(item.name)}</p>
                <p className='mb-0 text-sm'>
                  {item.likieesCount} {t('text_products')}
                </p>
              </div>
            </div>
          );
        })}
        {data.length > 5 && (
          <div className='category-block cursor-pointer' onClick={() => setShowMore(!showMore)}>
            <img width='100%' src={categoryImage} alt='seemore' />
            <p className='text-lg fw-500 d-flex align-items-center see-more-text justify-content-center'>
              {!showMore && <PlusExtraLargeIcon className='mr-4' />}
              {showMore ? t('text_see_less') : t('text_see_more')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Categories;
